import React, { useEffect, useRef, useState } from "react";
import PdgViewerComponent from "../../components/EngageTranslationComponent/PdfViewerComponent/PdfViewerComponent";
import PSPDFKit, { Instance as PSPDFInstance } from "pspdfkit";
import { useLoaderData, useLocation } from "react-router";

import BackBtn from "../../components/Template/Btns/BackBtn";
import { FontIcon } from "@fluentui/react";
import { Collapse, Popover, Select, Spin } from "antd";
import "./TranslationDetailPage.css";
import ConfirmStatusChangeModalContent from "../../components/TranslationDetailComponent/ConfirmStatusChangeModal";
import StatusUpdateSuccessfullyModal from "../../components/TranslationDetailComponent/StatusUpdatedSucessfullyModal";
import { useAppDispatch } from "../../redux/useAppDispatch";
import { fetchDocumentDetailsPresigned, resetUpdateStatusState, setCustomFont, switchAutoFresh } from "../../redux/EngageTranslation/EngageTranslationAction";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import PdfViewerComponent from "../../components/EngageTranslationComponent/PdfViewerComponent/PdfViewerComponent";
import LoadingPage from "../template/LoadingPage/LoadingPage";
import DocumentEditorViewer from "../../components/EngageTranslationComponent/DocumentEditorViewer/DocumentEditorViewer";
import axios from "axios";

function TranslationDetailPage(props: any) {
  const outputDocumentEditorRef = useRef(null) as any;
  const inputDocumentEditorRef = useRef(null) as any;
  const pdfViewer = useRef<HTMLDivElement>(null);
  const pdfWriteRef = useRef<HTMLDivElement>(null);
  const customFontsRef = useRef(null) as any;
  const [fetchFontLoading, setFetchFontLoading] = useState(false);
  const [confirmStatusChangeModalOpenState, setConfirmStatusChangeModalOpenState] = useState(false);
  const [statusUpdateSuccessfullyModalOpenState, setStatusUpdateSuccessfullyModalOpenState] = useState(false);
  const customFontState = useSelector((state: RootState) => state.engageTranslationState.customFonts);
  const [currentSelectedStatus, setCurrentSelectedStatus] = useState({
    disabled: false,
    key: "",
    label: "",
    title: "",
    value: "",
  });
  const location = useLocation();

  // const searchParams = new URLSearchParams(location.search);
  // const documentId = parseInt(searchParams.get("document") || "0");

  const urlDivided = location.pathname.split("/");
  const documentId = Number(urlDivided[urlDivided.length - 1]);

  const dispatch = useAppDispatch();
  const engageTranslationDetailPageState = useSelector((state: RootState) => state.engageTranslationState.engageTranslationDetailPageState);
  const fetcher = (fontFileName: string) =>
    fetch(`/dynamicFonts/${fontFileName}`, {
      // Adding Get request
      // Setting response type to arraybuffer
      // Setting response type to arraybuffer
    }).then(async (r) => {
      console.log(r);
      // fetch(
      //   "https://wl-dev-idp-engage-translate-docstore.s3.us-east-1.amazonaws.com/Testfile/NotoSansSC-Regular.otf?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjELL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLXNvdXRoZWFzdC0yIkcwRQIgQiIgwRSy%2BErrDV%2FuaQbca6O%2F1vNYKlKx%2BX5wYL136GsCIQCnrjEPruUQGENyadYY%2F1XIjJnR7vx3l%2BYWZdMHEZQJICqSAwiL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDg4OTA5NzE0NDgwNCIMYdTf%2FFRg4ng7dcblKuYC9OvzHyb0G35jilHhH3ovJGIJMjpAgwj4JllCXxv7c4iYD05SDn4gmkGBZ1G2brpb%2BLyejtkN1yMHTpmRZoZWFs8s49ahZGwWKZOIChMtQWNaoV3sW0P8VDv0tkI09t%2ByIxTmulImbCwJ4bM7jC8P1jul%2FfmCA0kZq63YNnGwnYPiL5T91DYWbnPARodu8LgQJlBaWTNCzXk%2FYg3GTkDnr3VM%2BGsFX3Q%2Fy8GvxpjiiFrEhBGOLLABCES%2BHl1zixN5tgcnxiYTc8qyybNnilCv3rRipWwBTf5Xzi9fPeSQU2IvldlDKG1oWGgQQr9TdTdUWI0dSv2Q7QAitfOA%2FqnWZMrSKEj2q95ayy%2Fh9hQGJeU9hEJNJPJcBtouFO8ImKM%2F472hUL6OvMAjcsIfIWdmQWhPFcvuVcKejgy%2Bq3MOvc%2BQ7zZ%2B6Kw%2BkE3bsx%2F%2FwuRPBr%2FUshTEKCaTQfKoEEop%2BJOJNfGO5TCtj7KuBjqzAjylhT%2Fa5prCyV45F2KPhszRQXNnL95zF9%2FP0SFECjMdPkgVZx5cH8y1mPip6RCg%2BszHi9xB4ItZhRgWoSn0rEDET02BYFg%2BnDsLP0pmfwpABTHmHJo0lIJANwwGpQVAaY6Ezzt3Xz4ALqtMUd0DWmkNVJ1HH%2BWDJtBe3I%2FE0hKygAIbyQsSbRmAxK%2BLMv0ulHmyVHKliJ64OR7t9%2BCtSCA0ze3f85USTSWt1soqVXFOQ0SY2XJRr0YqwvbHTfDcuZr80sDgN3%2BbTLcSfDHD8kfuOkR6Oc98gzd5s1nCN%2BJ97nh%2BAKDGQWNRbUYAEh1p%2BjTRBlaTbZlxM6QIHfjWsiss5xFuPyixdN5Al5vFNPHyQKdz6H7GK%2FQSk%2ByvOhaUxeGtNawMxRArMvet%2FbPhTJP2drA%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20240214T092902Z&X-Amz-SignedHeaders=host&X-Amz-Expires=43200&X-Amz-Credential=ASIA46ASRZHSM5ZSAR6I%2F20240214%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Signature=14b17f3843957a34b05af7c03e3f61abe6f5a470851ef02a5fc50398fc37d832"
      // ).then(async (r) => {
      if (r.ok) {
        return r.blob();
      } else {
        throw new Error();
      }
    });

  useEffect(() => {
    dispatch(fetchDocumentDetailsPresigned(documentId));
    if (customFontState === null) {
      const customFonts = ["NotoSansSC-Regular.otf", "NotoSansSC-Bold.otf", "NotoSansJP-Bold.otf", "NotoSansJP-Regular.otf", "NotoSansKR-Regular.otf", "NotoSansKR-Bold.otf", "NotoSansTC-Bold.otf", "NotoSansTC-Regular.otf"].map((font) => {
        const pspdfFont = new PSPDFKit.Font({
          name: font,
          callback: fetcher,
        });
        return pspdfFont;
      });
      dispatch(setCustomFont(customFonts));
    }

    // return () => {
    //   const parentElement = document.getElementById("document-detail-container");
    //   if (parentElement) {
    //     parentElement.innerHTML = "";
    //   }
    // };
  }, []);

  function openConfirmStatusChangeModal() {
    setConfirmStatusChangeModalOpenState(true);
  }
  function closeConfirmStatusChangeModal() {
    setConfirmStatusChangeModalOpenState(false);
  }

  function openStatusUpdateSuccessfullyModal() {
    setStatusUpdateSuccessfullyModalOpenState(true);
  }
  function closeStatusUpdateSuccessfullyModal() {
    setStatusUpdateSuccessfullyModalOpenState(false);
  }

  function isDocumentInProgress() {
    return engageTranslationDetailPageState.documentDetail.currentStatus === "Qc In Progress" || "OnHold In Progress";
  }

  function handleSelect(value: any) {
    setCurrentSelectedStatus(value);
    dispatch(resetUpdateStatusState());
    openConfirmStatusChangeModal();
  }
  if (engageTranslationDetailPageState.loading) {
    return <LoadingPage />;
  }
  const PopOverContent = () => {
    return (
      <div>
        <div>
          <b>Name: </b>
          <span>{engageTranslationDetailPageState.documentDetail.name}</span>
        </div>
        <div>
          <b>Input Language: </b>
          <span>{engageTranslationDetailPageState.documentDetail.sourceLanguageName}</span>
        </div>
        <div>
          <b>Output Language: </b>
          <span>{engageTranslationDetailPageState.documentDetail.targetLanguageName}</span>
        </div>
        <div>
          <b>Client Name: </b>
          <span>{engageTranslationDetailPageState.documentDetail.clientName}</span>
        </div>

        <div>
          <b>Uploaded by: </b>
          <span>{engageTranslationDetailPageState.documentDetail.uploadedBy}</span>
        </div>
        <div>
          <b>QC assigned to: </b>
          <span>{engageTranslationDetailPageState.documentDetail.qcAssignedTo}</span>
        </div>
      </div>
    );
  };

  return (
    <div
      id={"document-detail-container"}
      className="body-container d-flex flex-column px-3">
      <ConfirmStatusChangeModalContent
        open={openConfirmStatusChangeModal}
        close={closeConfirmStatusChangeModal}
        openStatusUpdateSuccessfullyModal={openStatusUpdateSuccessfullyModal}
        currentSelectedStatus={currentSelectedStatus}
        openState={confirmStatusChangeModalOpenState}
        documentId={documentId}
        setStatusUpdateSuccessfullyModalOpenState={setStatusUpdateSuccessfullyModalOpenState}
      />
      <StatusUpdateSuccessfullyModal
        open={openStatusUpdateSuccessfullyModal}
        close={closeStatusUpdateSuccessfullyModal}
        openState={statusUpdateSuccessfullyModalOpenState}
      />

      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <BackBtn backTo="quality-control" />
          <h5 className="document-detail-title">{engageTranslationDetailPageState.documentDetail.name}</h5>

          <Popover
            content={<PopOverContent />}
            title="Document Information">
            <FontIcon
              iconName="Info"
              className="document-detail-info-icon"
            />
          </Popover>
        </div>
        <div className="d-flex gap-3 align-items-center">
          <div className="status-dropdown">
            <span className="status-title">Status</span>
            <Select
              labelInValue
              disabled={!engageTranslationDetailPageState.documentDetail.isOutputDocEditable}
              value={{ value: engageTranslationDetailPageState.documentDetail.currentStatus, label: engageTranslationDetailPageState.documentDetail.currentStatus }}
              onChange={handleSelect}
              options={engageTranslationDetailPageState.statusDropDown}
            />
          </div>
        </div>
      </div>

      {engageTranslationDetailPageState.documentDetail.fileFormat === "pdf" ? (
        <div className="container-wrapper">
          <PdfViewerComponent
            document={engageTranslationDetailPageState.documentDetail.inputPathPresignedUrl}
            selectedDocumentID={documentId}
            editable={false}
            customFonts={customFontState}
            refContainer={pdfViewer}
          />

          <PdfViewerComponent
            customFonts={customFontState}
            refContainer={pdfWriteRef}
            document={engageTranslationDetailPageState.documentDetail.outputPathPresignedUrl}
            selectedDocumentID={documentId}
            editable={engageTranslationDetailPageState.documentDetail.isOutputDocEditable}
            // editable={!navigateState.isLock && isDocumentInProgress()}
          />
        </div>
      ) : (
        <div className="container-wrapper">
          <DocumentEditorViewer
            editable={false}
            document={engageTranslationDetailPageState.documentDetail.sfdtInput}
            refContainer={inputDocumentEditorRef}
          />
          <DocumentEditorViewer
            editable={engageTranslationDetailPageState.documentDetail.isOutputDocEditable}
            selectedDocumentID={documentId}
            document={engageTranslationDetailPageState.documentDetail.sfdtOutput}
            refContainer={outputDocumentEditorRef}
          />
        </div>
      )}
    </div>
  );
}

export default TranslationDetailPage;
